import { Injectable, computed, inject, signal } from '@angular/core';
import { LOCAL_STORAGE } from '@core/storage/storage.tokens';
import { LOCAL_KEYS } from '@core/storage/storage.keys';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class ConsentService {
  private readonly storage = inject(LOCAL_STORAGE);
  private readonly analytics = inject(AnalyticsService);

  private readonly _enabled = signal<boolean>(this.storage.get(LOCAL_KEYS.analyticsConsent));
  private readonly _decided = signal<boolean>(this.storage.get(LOCAL_KEYS.analyticsConsentDecided));

  readonly enabled = this._enabled.asReadonly();
  readonly decided = this._decided.asReadonly();
  readonly showBanner = computed(() => !this._decided());

  /** User accepted analytics from the banner. */
  accept(): void {
    this.persist(true);
  }

  /** User declined analytics from the banner. */
  decline(): void {
    this.persist(false);
  }

  /** Settings toggle changed. */
  setEnabled(on: boolean): void {
    this.persist(on);
  }

  /** Re-apply a persisted denial after gtag has loaded (startup reconciliation). */
  applyPersisted(): void {
    if (!this._enabled()) this.analytics.setConsent(false);
  }

  private persist(enabled: boolean): void {
    this._enabled.set(enabled);
    this._decided.set(true);
    this.storage.set(LOCAL_KEYS.analyticsConsent, enabled);
    this.storage.set(LOCAL_KEYS.analyticsConsentDecided, true);
    this.analytics.setConsent(enabled);
  }
}
